<template>
  <Notification :description="$t('rc_notifications_campaign_paused')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="onUpdateCampaignStatus"
        >
          <span v-if="isResumeCampaignLoading" class="tw:px-4">
            <SmallDotLoader color="#fff" />
          </span>
          <span v-else>{{ $t('notification_action_reactivate') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import { computed } from 'vue'

import Notification from './Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import appAnalytics from '@/utils/tracking'
import { useCampaign, useCampaignMutation } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useRateConnect } from '@/components/rateConnect/useRateConnect'

const { campaignsData } = useCampaign(selectedAccommodationId)
const { isResumeCampaignLoading } = useCampaignMutation()
const { toggleResumeCampaign } = useRateConnect()

const currentCampaignType = computed(() => campaignsData.value?.campaignType)

const onUpdateCampaignStatus = () => {
  trackDataInSegment()
  toggleResumeCampaign('open')
}

const trackDataInSegment = () => {
  appAnalytics.track(appAnalytics.events.TRC_CAMPAIGN_RESUMED, {
    item_id: selectedAccommodationId.value,
    campaign_type: currentCampaignType.value,
    budget: campaignsData.value?.budget,
    source: 'notification',
  })
}
</script>
